import React, { useState, useEffect } from "react";

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("verdade_oculta_cookie_consent");
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAcceptAll = () => {
        localStorage.setItem("verdade_oculta_cookie_consent", "all");
        setIsVisible(false);
    };

    const handleAcceptEssential = () => {
        localStorage.setItem("verdade_oculta_cookie_consent", "essential");
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div
            role="region"
            aria-labelledby="cookie-title"
            aria-describedby="cookie-description"
            className="fixed bottom-3 left-3 right-3 z-[100] max-h-[52vh] overflow-y-auto border border-[var(--line-strong)] bg-[var(--bg)]/95 backdrop-blur-md px-4 py-4 shadow-2xl md:bottom-0 md:left-0 md:right-0 md:max-h-[60vh] md:border-x-0 md:border-b-0 md:px-6 md:py-6"
        >
            <div className="mx-auto max-w-[1400px] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-6">
                
                {/* Text Section */}
                <div className="flex-1 space-y-2">
                    <div className="flex items-center gap-2">
                        <span style={{ color: "var(--classified)" }}>●</span>
                        <h3 id="cookie-title" className="font-serif font-bold text-base md:text-xl text-[var(--ink)] tracking-normal">
                            Aviso de Privacidade e Cookies
                        </h3>
                    </div>
                    <p id="cookie-description" className="font-serif text-[var(--ink)] text-xs md:text-base leading-relaxed max-w-3xl">
                        Este arquivo utiliza tecnologias de rastreamento estritamente necessárias para garantir a integridade da plataforma e a segurança do utilizador. Opcionalmente, utilizamos cookies analíticos para medir a difusão da verdade. Pode aceitar todos ou limitar aos essenciais.
                    </p>
                </div>

                {/* Actions Section */}
                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto shrink-0">
                    <button
                        type="button"
                        onClick={handleAcceptEssential}
                        className="min-h-11 border border-[var(--line-strong)] px-6 py-2.5 text-sm md:text-base font-serif italic text-[var(--ink-soft)] hover:text-[var(--ink)] hover:border-[var(--ink)] transition-colors whitespace-nowrap"
                    >
                        Apenas Essenciais
                    </button>
                    <button
                        type="button"
                        onClick={handleAcceptAll}
                        className="min-h-11 bg-[var(--ink)] text-[var(--paper)] px-6 py-2.5 text-sm md:text-base font-serif italic hover:bg-[var(--controversy)] transition-colors whitespace-nowrap"
                    >
                        Aceitar Todos
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
